import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import {NodeEnv} from "../../helpers/nodeEnv";
import Cookies from "universal-cookie";

const cookie = new Cookies();

const baseApi = axios.create();


baseApi.interceptors.request.use((config: AxiosRequestConfig) => {
    const allowedMethods = new Set<string>(["GET", "HEAD", "TRACE", "OPTIONS"]);

    if (config.method && allowedMethods.has(config.method.toUpperCase())) {
        config.headers = {
            ...config.headers,
            "X-XSRF-TOKEN": cookie.get("XSRF-TOKEN")
        };
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});


baseApi.interceptors.response.use((response: AxiosResponse) => {
    return response;
}, (error: AxiosError) => {
    console.error(error);

    if (error.response && error.response.status === 401) {
        window.location.href = window._env_.API_URL + "/oauth2/sign_in";
    } else {
        return error.response;
    }
});

if (process.env.NODE_ENV === NodeEnv.jestTest) {
    baseApi.get = jest.fn();
    baseApi.post = jest.fn();
    baseApi.delete = jest.fn();
    baseApi.put = jest.fn();
    baseApi.patch = jest.fn();
}

export default baseApi;
